import axios from 'src/utils/axios';
import { getAuthorizedUser, getUser } from 'src/utils/Common';
import { isMailOrbitMock } from 'src/utils/MailOrbitService';
import { workOrderEmailPath } from 'src/components/MailOrbit/StandaloneConversation/linkedWorkOrder';

/** Is emri acilamadiginda gosterilecek mesajin cevirisi (kisisel veri icermez). */
export const WORK_ORDER_NOT_ACCESSIBLE_KEY = 'mailorbitManual:work_order_not_accessible';

/**
 * Email2Case ile ayni on kosullari kurup is emri sayfasina gider (SR-028).
 *
 * WorkOrder sayfasi adresten dogrudan acilinca Redux'ta is emri olmadigi icin "Fis bulunamadi" der;
 * Email2Case akisinda (OutlookStyleEmailView.handleWorkOrderClick / TopBar onCaseSelect) once
 * GetConsumerByWorkOrderId cagrilip sonuc localStorage'a yazilir, sayfa bunu tek seferlik tuketir.
 * Bu yardimci ayni sirayi izler. Consumer verisi yalnizca localStorage'a yazilir; loglanmaz.
 *
 * @returns {Promise<boolean>} true: yonlendirildi; false: is emri yok ya da bu kullanici erisemiyor (yonlendirme yok).
 */
export const openWorkOrder = async (history, workOrderId, { tab } = {}) => {
  if (!history || !workOrderId) return false;
  const id = String(workOrderId);
  const target = tab ? `/WorkOrder/${id}/${tab}` : workOrderEmailPath(id);

  if (isMailOrbitMock()) {
    // Mock modda gercek is emri verisi yok; ag cagrisi atlanir.
    history.push(target);
    return true;
  }

  try {
    // Oturum kullanicisi: WorkOrder sayfasi ve TopBar ile ayni kaynak (getUser, oturum 'user').
    // Alan eksikse Email2Case'in kullandigi yetkili kullaniciya (authorizedUser) dusulur.
    const sessionUser = getUser() || {};
    const authorized = getAuthorizedUser() || {};
    const serviceShopId = sessionUser.ServiceShopId ?? authorized.ServiceShopId;
    const role = sessionUser.Role ?? authorized.Role;

    const response = await axios.get(`/GetConsumerByWorkOrderId/${id}/${serviceShopId}/${role}`);
    const consumerData = response && response.data && response.data[0];
    if (!consumerData) return false;

    // Her seferinde once temizle, sonra yaz (WorkOrder sayfasi tek seferlik tuketir).
    localStorage.removeItem('fromEmail2Case');
    localStorage.removeItem('email2CaseWorkOrderId');
    localStorage.removeItem('email2CaseConsumerData');

    localStorage.setItem('fromEmail2Case', 'true');
    localStorage.setItem('email2CaseWorkOrderId', id);
    localStorage.setItem('email2CaseConsumerData', JSON.stringify(consumerData));
  } catch (e) {
    return false; // nedeni loglanmaz (veri icerebilir)
  }

  history.push(target);
  return true;
};
